(function () {
    function isMobileMedia() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function syncVideoPoster(video) {
      if (!video) return;

      var host = video.closest('[data-responsive-video-poster]');
      if (!host) return;

      var poster = isMobileMedia()
        ? host.dataset.mobilePoster || host.dataset.poster || ''
        : host.dataset.poster || '';

      if (poster && video.getAttribute('poster') !== poster) {
        video.setAttribute('poster', poster);
      }
    }

    function initAceiiFlowCarousel() {
      var sections = document.querySelectorAll('[data-aceii-flow-carousel]');

      sections.forEach(function (section) {
      if (section.dataset.initialized === 'true') return;

      section.dataset.initialized = 'true';

      var slides = Array.prototype.slice.call(section.querySelectorAll('.afc-slide'));
      var dots = Array.prototype.slice.call(section.querySelectorAll('.afc-dots button'));
      var prevBtn = section.querySelector('.afc-arrow-prev');
      var nextBtn = section.querySelector('.afc-arrow-next');

      var current = 0;
      var timer = null;
      var delay = 5600;
      var isSectionActive = false;

      if (!slides.length) return;

      slides.forEach(function (slide) {
        syncVideoPoster(slide.querySelector('.afc-video'));
      });

      function canRun() {
        return isSectionActive && !document.hidden;
      }

      function loadVideo(video, preload) {
        if (!video) return;

        var didAttachSource = false;

        syncVideoPoster(video);
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = preload || 'metadata';

        if (video.dataset.src && !video.getAttribute('src')) {
          video.setAttribute('src', video.dataset.src);
          didAttachSource = true;
        }

        Array.prototype.slice.call(video.querySelectorAll('source')).forEach(function (source) {
          if (source.dataset.src && !source.getAttribute('src')) {
            source.setAttribute('src', source.dataset.src);
            didAttachSource = true;
          }
        });

        if (didAttachSource || video.readyState === 0) {
          video.load();
        }
      }

      function pauseAllVideos() {
        slides.forEach(function (slide) {
          var video = slide.querySelector('.afc-video');

          if (video) {
            video.pause();
          }
        });
      }

      function playActiveVideo() {
        if (!canRun()) return;

        var activeSlide = slides[current];
        if (!activeSlide) return;

        var video = activeSlide.querySelector('.afc-video');

        if (video) {
          loadVideo(video, 'auto');
          video.currentTime = 0;

          var playPromise = video.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        }
      }

      function preloadNextVideo() {
        if (!canRun() || slides.length < 2) return;

        var nextSlide = slides[(current + 1) % slides.length];
        var video = nextSlide ? nextSlide.querySelector('.afc-video') : null;

        if (video) {
          loadVideo(video, 'metadata');
        }
      }

      function updateProgress() {
        dots.forEach(function (dot, index) {
          dot.classList.remove('is-active');
          dot.classList.remove('is-running');
          dot.style.setProperty('--afc-progress-duration', delay + 'ms');

          if (index === current) {
            dot.classList.add('is-active');
            dot.offsetWidth;

            if (canRun()) {
              requestAnimationFrame(function () {
                dot.classList.add('is-running');
              });
            }
          }
        });
      }

      function updateSlides() {
        var total = slides.length;
        var prevIndex = (current - 1 + total) % total;
        var nextIndex = (current + 1) % total;

        slides.forEach(function (slide, index) {
          slide.classList.remove('is-active', 'is-prev', 'is-next', 'is-hidden');

          if (index === current) {
            slide.classList.add('is-active');
          } else if (index === prevIndex) {
            slide.classList.add('is-prev');
          } else if (index === nextIndex) {
            slide.classList.add('is-next');
          } else {
            slide.classList.add('is-hidden');
          }
        });

        updateProgress();

        pauseAllVideos();
        playActiveVideo();
        preloadNextVideo();
      }

      function goTo(index) {
        current = (index + slides.length) % slides.length;
        updateSlides();
        restartAuto();
      }

      function next() {
        goTo(current + 1);
      }

      function prev() {
        goTo(current - 1);
      }

      function startAuto() {
        if (!canRun()) return;

        stopAuto();
        timer = window.setInterval(next, delay);
      }

      function stopAuto() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function restartAuto() {
        stopAuto();
        startAuto();
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.getAttribute('data-index'), 10));
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', prev);
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', next);
      }

      section.addEventListener('mouseenter', stopAuto);
      section.addEventListener('mouseleave', startAuto);

      window.addEventListener('resize', function () {
        slides.forEach(function (slide) {
          syncVideoPoster(slide.querySelector('.afc-video'));
        });
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAuto();
          pauseAllVideos();
          updateProgress();
        } else if (isSectionActive) {
          updateSlides();
          startAuto();
        }
      });

      updateSlides();

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            isSectionActive = entry.isIntersecting;

            if (isSectionActive) {
              updateSlides();
              startAuto();
            } else {
              stopAuto();
              pauseAllVideos();
              updateProgress();
            }
          });
        }, {
          root: null,
          rootMargin: '300px 0px',
          threshold: 0.01
        });

        observer.observe(section);
      } else {
        isSectionActive = true;
        updateSlides();
        startAuto();
      }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAceiiFlowCarousel);
    } else {
      initAceiiFlowCarousel();
    }

    document.addEventListener('shopify:section:load', initAceiiFlowCarousel);
  })();
